import gql from 'graphql-tag';
import { lightUserFragment } from './light-user.fragment';
import { commentVoteFragment } from './vote.fragment';
import { linkFragment } from './link.fragment';

export const CommentFragment = gql`
  fragment CommentFragment on Comment {
    Id
    body
    lastEdited

    myVote

    replyCount

    author {
      ...lightUserFragment
    }

    votes {
      ...commentVoteFragment
    }

    images {
      ...linkFragment
    }
  }
  ${lightUserFragment}
  ${commentVoteFragment}
  ${linkFragment}
`;
